import { useCallback } from "react";

import { ConfigFileStatusType } from "../../../entities/ConfigFileStatus";
import { useTerminalContext } from "../contexts/TerminalContext";
import { configApi } from "../services/configApi";
import { createWithLoading, wrapError } from "../utils/configApiHelpers";

/**
 * Hook for saving config files
 */
export const useConfigFileSaver = () => {
  const {
    readyConfig,
    setConfigFileStatus,
    setFileList,
    setError,
    setIsLoading
  } = useTerminalContext();

  const saveReadyConfig = useCallback(
    async (terminalId: number, src: string, status: ConfigFileStatusType) => {
      if (!terminalId || !readyConfig) {
        throw new Error("No terminal or config loaded");
      }
      setError(null);
      const withLoading = createWithLoading(setIsLoading);
      return withLoading(async () => {
        try {
          await configApi.saveReadyConfig(terminalId, src, readyConfig, status);
          setConfigFileStatus(status);
          const refreshedFiles = await configApi.fetchConfigFiles(terminalId);
          setFileList(refreshedFiles);
        } catch (error: any) {
          throw wrapError("Save config failed", error);
        }
      });
    },
    [readyConfig, setConfigFileStatus, setError, setIsLoading, setFileList]
  );

  return { saveReadyConfig };
};
